import type { AuthSession, Message } from "./types";
import { authenticatedFetch } from "./auth";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL as string | undefined;

export async function saveInternalNote(
  conversationId: string,
  note: string,
  session: AuthSession,
): Promise<Message> {
  if (!API_BASE_URL) throw new Error("API_NOT_CONFIGURED");
  const response = await authenticatedFetch(
    `${API_BASE_URL}/conversations/${encodeURIComponent(conversationId)}/notes`,
    session,
    {
      method: "POST",
      body: JSON.stringify({ body: note }),
    },
  );
  const payload = (await response.json().catch(() => ({}))) as { item?: Message; error?: string };
  if (!response.ok || !payload.item) throw new Error(payload.error ?? `HTTP_${response.status}`);
  return payload.item;
}
